<template>
  <button :class="classObject" :disabled="isDisabled" :type="type" class="btn" @click="handleClick">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    variant: {
      type: String,
      default: 'primary',
    },
    isBlock: {
      type: Boolean,
      default: false,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    classObject() {
      return [this.variant, { 'qt-loader qt-loader-mini qt-loader-right': this.loading }, { 'btn-block': this.isBlock }, { 'btn-icon': this.isIcon }];
    },
    isDisabled() {
      return this.disabled || this.loading;
    },
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  line-height: 26px;
  font-size: 0.875rem;
  padding: 6px 24px;
  transition: 0.5s;
  border-radius: 8px;
  font-weight: 500;

  &:hover {
    filter: brightness(70%);
  }

  &.primary {
    background-color: var(--clr-yup-purple);
    color: #fff;
  }

  &.secondary {
    background-color: #fff;
    border-color: var(--clr-yup-purple);
    color: var(--clr-yup-purple);
  }

  &.tertiary {
    background-color: transparent;
    color: var(--clr-yup-purple);
  }

  &.danger {
    background-color: #ad001a;
    color: #fff;
  }

  &.light {
    background-color: rgb(216, 222, 235);
    color: rgb(67, 85, 108);
  }

  &.link {
    padding: 0;
  }

  &.btn-icon {
    padding: 6px 6px;
  }

  &.qt-loader.qt-loader-right {
    padding-right: 40px;
  }

  a {
    color: inherit;
  }

  .material-symbols-outlined {
    display: inline-block;
    vertical-align: text-bottom;
    font-size: 22px;
  }

  .material-icons-outlined {
    display: inline-block;
    vertical-align: text-bottom;
    font-size: 22px;
  }
}

.register {
  .btn {
    margin-bottom: 26px;
  }
}
</style>
